import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { usePublicOrgInfoQuery } from 'src/shared/graphql/generated';
import { useGlobalStorageContext } from 'src/shared/hooks/useGlobalStorage';
import { useEmbedContext } from 'src/shared/providers/Embed';
import { isServer } from 'src/shared/utils/environment';

export const useViewSampleImageEmbed = () => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const publicIdentifier = queryParams.get('aff_org_id');
  const embedConfigurationId = queryParams.get('embedConfigId');
  // If an originalImageId is passed into the embed, that should override the configuations
  const customOriginalImageId = queryParams.get('originalImageId') || undefined;

  const {
    isEmbed,
    setEmbedOrgId,
    embedOrgId,
    setEmbedConfigId,
    embedConfigId,
    showLandingPage,
    originalImageId,
  } = useEmbedContext();

  if (embedConfigurationId) {
    setEmbedConfigId(Number(embedConfigurationId));
  }

  // Will be used for feature accesses
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { data, loading } = usePublicOrgInfoQuery({
    variables: {
      publicIdentifier: publicIdentifier || '',
    },
    skip: !publicIdentifier,
  });

  const { setAffOrgPublicId } = useGlobalStorageContext();

  useEffect(() => {
    if (publicIdentifier) setAffOrgPublicId(publicIdentifier);
  }, [publicIdentifier, setAffOrgPublicId]);

  useEffect(() => {
    if (data?.publicOrgInfo?.id) {
      setEmbedOrgId(data.publicOrgInfo?.id);
    }
  }, [data, embedOrgId, setEmbedOrgId]);

  const isLoading = isServer() || loading;

  const canViewSampleImageEmbed = isEmbed && showLandingPage;

  return {
    canViewSampleImageEmbed,
    isLoading,
    embedConfigId,
    originalImageId: customOriginalImageId || originalImageId,
  };
};
